import { isSupported, sanitize } from 'isomorphic-dompurify';

export const sanitizeHtml = (html: string, ctx = {}) => (isSupported ? sanitize(html, ctx) : html);
